const searchPriceParams = () => {
  const url = window.location.search.substr(1);
  if (!url) return;

  const params = new URLSearchParams(url);

  const minPrice = params.get('price_min');
  const maxPrice = params.get('price_max');

  $('#price_min').val(minPrice);
  $('#price_max').val(maxPrice);
};

const categoryValidations = () => {
  const startDate = $('#date_start');
  const endDate = $('#date_end');
  const priceMin = $('#price_min');
  const priceMax = $('#price_max');
  const alertMessageDate = $('.filter-alert--date');
  const alertMessagePrice = $('.filter-alert--price');
  const alertMessageEmpty = $('.filter-alert--empty');
  const filterBtn = $('.filter__button');

  searchPriceParams();

  $('#price_min, #price_max').mask('000.000.000.000.000,00', { reverse: true });

  $('#date_start, #date_end').on('keyup', () => {
    if (parseInt(startDate.val(), 10) > parseInt(endDate.val(), 10)) {
      alertMessageDate.show();
      filterBtn.attr('disabled', 'true');
    } else {
      alertMessageDate.hide();
      filterBtn.removeAttr('disabled');
    }
  });

  $('#price_min, #price_max').on('keyup', () => {
    if (priceMax.val()) {
      const minPriceConverted = priceMin.val().replace('.', '').replace(',', '.');
      const maxPriceConverted = priceMax.val().replace('.', '').replace(',', '.');

      const minPrice = parseFloat(minPriceConverted);
      const maxPrice = parseFloat(maxPriceConverted);

      if (minPrice > maxPrice) {
        alertMessagePrice.show();
        filterBtn.attr('disabled', 'true');
      } else if (!!maxPrice && !minPrice) {
        alertMessagePrice.hide();
        alertMessageEmpty.show();
        filterBtn.attr('disabled', 'true');
      } else {
        alertMessagePrice.hide();
        alertMessageEmpty.hide();
        filterBtn.removeAttr('disabled');
      }
    } else {
      alertMessagePrice.hide();
      alertMessageEmpty.hide();
      filterBtn.removeAttr('disabled');
    }
  });
};

export default categoryValidations;



// WEBPACK FOOTER //
// /app/app/assets/javascripts/packs/books/category_validations.js